<template>
  <div class="import-users">
    <LTSHeader></LTSHeader>
    <div class="container">
      <div v-if="error" class="card">
        <div class="card-header bg-danger text-white text-bold text-center">{{ error }}</div>
      </div>
      <div class="settings">
        <div class="header-section">
          <div class="text-bold">Import Users</div>
          <div class="back-btn">
            <router-link class="btn-sm bg-primary text-white text-bold" to="/links">
              <img src="../assets/arrow-left.svg" alt /> Back
            </router-link>
          </div>
        </div>
        <div>
          <label for="file">Select file to upload...</label>
          <input
            class="ml-1"
            type="file"
            id="file"
            name="file"
            ref="file"
            v-on:change="handleFileUpload()"
          />
          <button
            @click.prevent="submitFile"
            :disabled="uploadDisabled"
            class="btn bg-primary text-white"
          >Upload</button>
          <span
            v-if="fileid"
            class="ml-2"
          >{{ uploading ? "uploading..." : "Successfully uploaded" }}</span>
        </div>
        <div>
          <label for="databases">Database</label>
          <select
            name="databases"
            class="select-css"
            id="databases"
            v-model="selectedDatabase"
            :disabled="!isPreProcess"
          >
            <option disabled selected value>-- please select --</option>
            <option
              v-for="database in settings.databases"
              :key="database"
              :value="database"
            >{{ database }}</option>
          </select>
        </div>
        <div class="process-buttons mt-2" style="display:unset;">
          <div style="float:left;">
              <a v-if="completed" @click.prevent="downloadResult" class="linktext" style="float:left;">Download Result File</a>
              <a v-if="completed2" @click.prevent="downloadResult2" class="linktext" style="float:left;padding-left:20px;">Download User Details File</a>
          </div>
          <div style="float:right;">
          <button
            @click.prevent="cancelImport"
            class="btn bg-primary text-white mr-2"
          >{{ completed ? "Reset" : "Cancel" }}</button>
          <button
            @click.prevent="process"
            class="btn bg-primary text-white"
            :disabled="importDisabled || completed"
          >{{ isPreProcess ? "Prep" : "P" }}rocess</button>
          </div>          
        </div>
      </div>
    </div>
<Loader v-show="processing" class="processing-loader"></Loader>
    <div v-if="!importDisabled && !completed" class="import-table">
          
      <table>
        <tr>
          <th v-for="col in uploadData.columns" :key="col.name">{{ col.name }}</th>
        </tr>
        <tr v-for="(row, i) in uploadData.rows" :key="i">
          <td v-for="(cell, j) in row.cells" :key="j">{{ cell.value }}</td>
        </tr>
      </table>
    </div>
    <div v-if="completed" class="import-table">
      <table style="width:500px;margin:auto;border:none;margin-top:25px;">
        <tr style="font-weight:bold;">
          <td>Firms Updated: </td>
          <td>
            <ol>
              <li v-for="item in uploadData.results.firms" :key="item.firm">
                {{ item.firm }}
            </li>
            </ol>
          </td>
        </tr>
        <tr style="font-weight:bold;">
          <td>Database: </td>
          <td>{{uploadData.results.databaseName}}</td>
        </tr>
        <tr style="font-weight:bold;">
          <td>Update Date: </td>
          <td>{{uploadData.results.updateDate}}</td>
        </tr>
        <tr style="font-weight:bold;">
          <td>Update By: </td>
          <td>{{ UpdatedBy }}</td>
        </tr>
      </table>
      <table style="width:500px;margin:auto;margin-top:25px;border-color:#7f95be;border-style:solid;border-width:0.5px;">
        <tr>
          <th colspan="1">Total number of Upload lines</th>
          <th colspan="1" style="text-align:center;">{{uploadData.results.total}}</th>
        </tr>
        <tr>
          <td colspan="2" style="background-color:#d9e1f2;font-weight:bold;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">IND = C(Create)</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:#f2f2f2;font-weight:bold;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Create request lines</td>
          <td colspan="1" style="background-color:#f2f2f2;font-weight:bold;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;text-align:center;">{{uploadData.results.cCount}}</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Number of successful creates</td>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;text-align:center;">{{uploadData.results.cSuccessCount}}</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Number of errors</td>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;text-align:center;">{{uploadData.results.cFailCount}}</td>
        </tr>
        <tr>
          <td colspan="2" style="background-color:#d9e1f2;font-weight:bold;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">IND = U(Update)</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:#f2f2f2;font-weight:bold;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Update request lines</td>
          <td colspan="1" style="background-color:#f2f2f2;font-weight:bold;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;text-align:center;">{{uploadData.results.uCount}}</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Number of successful updates</td>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;text-align:center;">{{uploadData.results.uSuccessCount}}</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Number of errors</td>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;text-align:center;">{{uploadData.results.uFailCount}}</td>
        </tr>
        <tr>
          <td colspan="2" style="background-color:#d9e1f2;font-weight:bold;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">IND = D(Deactivate)</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:#f2f2f2;font-weight:bold;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Deactivate request lines</td>
          <td colspan="1" style="background-color:#f2f2f2;font-weight:bold;color:black;text-align:center;border-color:#7f95be;border-style:solid;border-width:0.5px;">{{uploadData.results.dCount}}</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Number of successful deactivates</td>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;text-align:center;">{{uploadData.results.dSuccessCount}}</td>
        </tr>
        <tr>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;">Number of errors</td>
          <td colspan="1" style="background-color:white;color:black;border-color:#7f95be;border-style:solid;border-width:0.5px;text-align:center;">{{uploadData.results.dFailCount}}</td>
        </tr>
      </table>
    </div>
    
  </div>
</template>

<script>
import LTSHeader from "@/components/LTSHeader";
import Loader from "@/components/Loader.vue";
import axios from "axios";
import { saveAs } from "file-saver";

export default {
  components: {
    LTSHeader,
    Loader
  },
  data: () => {
    return {
      error: "",
      uploading: false,
      file: "",
      fileid: "",
      selectedDatabase: "",
      settings: {},
      uploadData: {},
      isPreProcess: true,
      processing: false,
      completed: false,
      completed2: false,
      UpdatedBy: ""
    };
  },
  mounted() {
    axios
      .get("/userimport")
      .then(response => {
        this.settings = response.data;
        // console.log(this.settings);
      })
      .catch(err => {
        this.error =
          "Could not load the settings from the server. Please contact technical support.";
        console.log(err.response);
      });
  },
  computed: {
    uploadDisabled: function() {
      return this.uploading || this.fileid.length > 0;
    },
    importDisabled: function() {
      return (
        this.fileid.length === 0 ||
        this.selectedDatabase.length === 0 ||
        this.processing
      );
    }
  },
  methods: {
    handleFileUpload: function() {
      this.file = this.$refs.file.files[0];
    },
    submitFile: function() {
      this.uploading = true;

      //Get Uploaded File Name
      this.uploadFileName = this.file.name;

      let formData = new FormData();
      formData.append("file", this.file);

      axios
        .post("/userimport/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.fileid = response.data;
        })
        .catch(err => {
          this.error =
            "Error occured while uploading the file. Please try again or contact technical support.";
          console.log(err.response);
        });

      this.uploading = false;
    },
    cancelImport: function() {
      this.error = "";
      this.uploading = false;
      this.$refs.file.value = null;
      this.file = "";
      this.fileid = "";
      this.selectedDatabase = "";
      this.uploadData = {};
      this.isPreProcess = true;
      this.processing = false;
      this.completed = false;
      this.completed2 = false;
      this.UpdatedBy = "";
    },
    process: function() {
      this.processing = true;
       axios
         .post("/userimport/process", {
           templateId: this.selectedDatabase,
           importFileId: this.fileid,
           process: !this.isPreProcess
         })
         .then(response => {
          this.uploadData = response.data;

           if (this.isPreProcess) {
            // Make sure the next click is to actually process the file.
             this.isPreProcess = false;
             this.processing = false;
           } else {          
             this.completed = true;   
             //Get Result Details 
             axios
              .get("/userimport/userdetailresult/" + this.fileid, {
                responseType: "blob"
              })
              .then(respon => {
                if(respon)
                {
                  this.completed2 = true;
                }
              })
              
              //Get Current logged in user
              axios
              .get("/Users/me")
              .then(respon => {
                if(respon)
                {
                  this.UpdatedBy = respon.data.surname + ', ' + respon.data.name;
                }
              })

              this.processing = false;
           }
         })
         .catch(err => {
           this.error =
           "Error occured while processing the import file. Please make sure that you are using the correct template for the selected database, otherwise contact technical support.";
           console.log(err.response);
           this.processing = false;
         });
      
      
    },
    downloadResult: function() {
      axios
        .get("/userimport/result/" + this.fileid, {
          responseType: "blob"
        })
        .then(response => {
          //Amended by Jaco: Update Response File Name with Upload File Name as well as the Date
          //Removing the xlsx or xls to only get the file name back from the upload control
          this.responseFileName = this.uploadFileName.replace(".xlsx", "_");
          this.responseFileName = this.responseFileName.replace(".xls", "_");
          //Get the date for the current day in yyyy-MM-dd
          const formatYmd = date => date.toISOString().slice(0, 10);
                    
          // console.log(response.data);
          saveAs(response.data, this.responseFileName + "Import_Results_" + formatYmd(new Date()) + ".XLSX");
        })
        .catch(err => {
          this.error =
            "Could not download the results file from the server. Please contact technical support.";
          console.log(err.response);
        });      
    },
    downloadResult2: function(){
      axios
        .get("/userimport/userdetailresult/" + this.fileid, {
          responseType: "blob"
        })
        .then(response => {
          //Amended by Jaco: Update Response File Name with Upload File Name as well as the Date
          //Removing the xlsx or xls to only get the file name back from the upload control
          this.responseFileName = this.uploadFileName.replace(".xlsx", "_");
          this.responseFileName = this.responseFileName.replace(".xls", "_");
          //Get the date for the current day in yyyy-MM-dd
          const formatYmd = date => date.toISOString().slice(0, 10);
                    
          // console.log(response.data);
          saveAs(response.data, this.responseFileName + "User_Details_" + formatYmd(new Date()) + ".XLSX");

        })  
    }
  }
};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.header-section {
  display: flex;
  justify-content: space-between;
}

.settings {
  //   max-width: 50%;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
}

.back-btn {
  margin-left: auto;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    img {
      padding-right: 5px;
    }
  }
}

.processing-loader {
  height: 5rem;
  margin: 0 auto;
}

.process-buttons {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
}

.import-table {
  margin: 1rem auto;
  width: 99vw;
  height: 70vh;
  overflow: auto;
  background: #f8f8ff;
  border: 1px solid $grey-color;

  table {
    width: 100%;
    background: #f8f8ff;
    border: 1px solid $grey-color;
    border-collapse: collapse;
    font-size: 0.8rem;

    th {
      text-align: left;
      padding: 0.8rem;
      font-weight: bold;
      background: $dark-blue-color;
      color: $white-color;
    }

    td {
      padding: 0.2rem 0.8rem;
      white-space: nowrap;
    }
  }
}

.results {
  margin: 5rem auto;
  width: 200px;
  padding: 10px;
  height: 70px;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  border-radius: 3px;
}
</style>
